﻿export class HostDefunct {
    static eventName() { return 'HostDefunct'; }

    eventName = HostDefunct.eventName;
}